import { useCurrentUser } from './useCurrentUser';
/**
 * Resolves every piece of pricing + stock state a product page needs in one place.
 * Bespoke pages read from this so we never scatter ad-hoc "if wholesaler" / "if out of stock"
 * branching across components.
 *
 * Wholesale totals in the cart/checkout are resolved server-side via `ResolveCartPrices`;
 * this hook is about what to render on the PDP itself.
 */ export function usePricingContext(product) {
    const { isWholesaler } = useCurrentUser();
    const inStock = product.inStock;
    const leadTimeDays = product.leadTimeDays;
    const isInDevelopment = product.lifecycle === 'in_development';
    // In-development short-circuits everything: no Add-to-Cart path until the
    // product flips to "available". The CTA in that mode is rendered by
    // NotifySignup — `ctaLabel` here exists for the rare consumer that just
    // wants a status string.
    let ctaLabel = 'Add to Cart';
    let canAddToCart = true;
    if (isInDevelopment) {
        ctaLabel = 'Notify me on launch';
        canAddToCart = false;
    } else if (!inStock) {
        if (leadTimeDays > 0) {
            ctaLabel = `Ships in ${leadTimeDays} day${leadTimeDays === 1 ? '' : 's'}`;
        } else {
            ctaLabel = 'Out of Stock';
            canAddToCart = false;
        }
    }
    return {
        product,
        displayPriceCents: Number(product.priceCents),
        tierTable: product.wholesaleTiers,
        defaultWholesaleDiscountPct: product.defaultWholesaleDiscountPct,
        isWholesaler,
        inStock,
        leadTimeDays,
        ctaLabel,
        canAddToCart,
        isInDevelopment,
        notifySubscriberCount: product.notifySubscriberCount
    };
}
